// Promo 8 — "Inside a week" (training calendar overview)
import { PromoStage, BgPhoto, PHOTOS, FULL_PB } from "@/pages/promo/_stage";
import { motion } from "framer-motion";

const WEEK = [
  { day: "Mon", title: "Lower power", line: "Squat. Hinge. Send it." },
  { day: "Tue", title: "Push", line: "Upper body strength + accessories." },
  { day: "Wed", title: "Active recovery", line: "Walk. Mobility. Sauna." },
  { day: "Thu", title: "Pull", line: "Back. Biceps. Posterior chain." },
  { day: "Fri", title: "Full body", line: "Compound circuits. Conditioning." },
  { day: "Sat", title: "Cardio + core", line: "Zone 2. Ab finisher." },
  { day: "Sun", title: "Off", line: "Eat. Sleep. Reset." },
];

const SLIDES = [
  {
    id: "open",
    duration: 2000,
    bg: "#0A0A0A",
    full: true,
    render: () => (
      <>
        <BgPhoto src={PHOTOS.about} kenBurns="in" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/60 to-black/20" />
        <div className="absolute inset-0 flex flex-col justify-end px-16" style={{ paddingBottom: FULL_PB + 20 }}>
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} className="text-[#FF1B91] uppercase tracking-[0.5em] text-sm font-bold mb-5">
            / Inside a week
          </motion.p>
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.65 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "200px" }}>
            What I<br />
            <span className="text-[#FF1B91]">build you.</span>
          </motion.h1>
        </div>
      </>
    ),
  },
  ...WEEK.map((d, idx) => ({
    id: `day-${d.day}`,
    duration: 1500,
    bg: idx % 2 === 0 ? "#0A0A0A" : "#FF1B91",
    render: () => (
      <div className="flex flex-col justify-center w-full h-full">
        <motion.p initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.35 }} className={`uppercase tracking-[0.5em] text-base font-bold mb-4 ${idx % 2 === 0 ? "text-[#FF1B91]" : "text-white"}`}>
          / {d.day}
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.45, delay: 0.1 }} className={`font-display font-black uppercase leading-[0.85] tracking-tighter ${idx % 2 === 0 ? "text-white" : "text-white"}`} style={{ fontSize: "150px" }}>
          {d.title}
        </motion.h2>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4, delay: 0.35 }} className={`mt-6 text-2xl font-semibold leading-snug ${idx % 2 === 0 ? "text-white/75" : "text-white"}`}>
          {d.line}
        </motion.p>
      </div>
    ),
  })),
  {
    id: "cta",
    duration: 2500,
    bg: "#FF1B91",
    render: () => (
      <div className="flex flex-col items-center justify-center w-full h-full text-center">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4 }} className="text-white uppercase tracking-[0.5em] text-sm font-bold mb-10">
          / Your week, sorted
        </motion.p>
        <motion.h2 initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.6 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "200px" }}>
          Built<br />
          <span className="font-brush font-normal normal-case -rotate-3 inline-block" style={{ fontSize: "220px" }}>for you.</span>
        </motion.h2>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.7 }} className="mt-10 text-white text-3xl font-bold tracking-tight">
          sweatwithslay.com
        </motion.p>
      </div>
    ),
  },
];

export default function Promo8() { return <PromoStage slides={SLIDES} />; }
